import styled, { css } from "styled-components";
import { pxToRem } from "../../styles/utils";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: ${pxToRem(16)};
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.1);
  width: ${pxToRem(429)};
  background: rgb(255, 255, 255);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${pxToRem(20)} ${pxToRem(30)};

  h2 {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 700;
    margin: 0;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: ${pxToRem(1)};
  background-color: rgb(225, 224, 229);
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  font-size: ${pxToRem(24)};
  color: #ccc;
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;

export const ModalBody = styled.div`
  margin-bottom: ${pxToRem(20)};
`;

export const InfoText = styled.p`
  gap: ${pxToRem(2)};
  display: flex;
  font-size: ${pxToRem(18)};
  font-weight: 700;
  margin: ${pxToRem(30)} ${pxToRem(30)} ${pxToRem(32)};
`;

export const HighlightText = styled.span`
  color: rgb(114, 82, 220);
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(16)};
  margin: 0 ${pxToRem(30)} ${pxToRem(30)};
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: ${pxToRem(12)};
  border: ${pxToRem(1)} solid #e1e0e5;
  border-radius: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
  color: #1f0a35;

  ${({ hasError }) =>
    hasError &&
    css`
      border-color: #f22862;
    `}

  &:focus {
    outline: none;
    border-color: #723edc;
  }
`;

export const ErrorMessage = styled.div`
  color: #f22862;
  font-size: ${pxToRem(12)};
  margin-bottom: ${pxToRem(8)};
`;

export const ModalFooter = styled.div`
  padding: 0 ${pxToRem(30)} 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: ${pxToRem(14)};
    color: rgba(31, 10, 53, 0.5);
    cursor: pointer;
    margin: ${pxToRem(16)} 0 ${pxToRem(30)};

    &:hover {
      text-decoration: none;
    }
  }
`;
